
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getLogList } from '@/api/gcash/account'
import { delObjEmptyKey, parseTime } from '@/utils'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'

@Component({
  name: 'paymentLog',
  components: {},
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
})
export default class extends Vue {
  @Prop({ required: true }) info!: any

  private queryForm: any = {
    search: '',
    // open_date: '',
    start_time: null,
    end_time: null,
    gcash_account: this.info.id,
    pay_type: '2'
  }
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }
  private logList: any[] = []
  private listLoading: boolean = false
  private total = 0

  private back() {
    this.$emit('close')
  }

  private select() {
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      search: '',
      // open_date: '',
      start_time: null,
      end_time: null,
      gcash_account: '',
      pay_type: '2'
    }
    this.date = getCurrentDate()
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getLogList(data).then((res: any) => {
        this.logList = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.logList = []
      this.listLoading = false
    }
  }

  private async init() {
    await this.hadleGetFilesListApi()
  }

  mounted() {
    this.init()
  }
}
